const encoder = typeof TextEncoder !== 'undefined' ? new TextEncoder() : null;
const decoder = typeof TextDecoder !== 'undefined' ? new TextDecoder() : null;

const encodeBytes = (bytes) => {
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
};

const decodeBytes = (encoded) => {
  const binary = atob(encoded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

export const encodeJsonPayload = (payload) => {
  if (!encoder) {
    throw new Error('TextEncoder is not supported in this environment.');
  }
  const json = JSON.stringify(payload);
  const bytes = encoder.encode(json);
  return encodeBytes(bytes);
};

export const decodeJsonPayload = (encoded) => {
  if (!decoder) {
    throw new Error('TextDecoder is not supported in this environment.');
  }
  const bytes = decodeBytes(encoded);
  const json = decoder.decode(bytes);
  return JSON.parse(json);
};
